import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Home() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  function getData() {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}api/course/open/getCourses`)
      .then((result) => {
        setData(result.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }

  useEffect(() => getData(), []);
  localStorage.clear();

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-custom sticky-top">
        <div className="container-fluid px-4">
          <a className="navbar-brand fw-bold text-dark d-flex align-items-center gap-2" href="/">
            <span className="text-white px-2 py-1 rounded" style={{ backgroundColor: '#0ea5e9' }}>Q</span>
            Online Quiz
          </a>
          <div className="d-flex align-items-center gap-3">
            <a className="btn btn-custom-outline btn-sm px-5 py-2 shadow-sm" href="/login">
              Login
            </a>
            <a className="btn btn-custom-primary btn-sm px-5 py-2 shadow-sm" href="/add-user">
              Register
            </a>
          </div>
        </div>
      </nav>

      <div className="container-fluid px-4 pb-5 main">

        {loading && (
          <div className="text-center py-5">
            <div className="spinner-border" style={{ color: '#0ea5e9' }} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        <div className="row g-4 p-3 pt-3">
          {data.map((course, index) => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={index}>
              <div className="course-card p-4 d-flex flex-column justify-content-between">
                <div>
                  <a href={"/candidate-login/"+course.id} className="text-decoration-none">
                    <h5 className="fw-bold text-dark mb-2 text-truncate">{course.name}</h5>
                    <p className="text-muted small mb-4" style={{ display: '-webkit-box', WebkitLineClamp: '2', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                      {course.description}
                    </p>
                     <a className="text-decoration-none fw-bold small" style={{ color: '#0ea5e9' }}>Start Quiz &rarr;</a>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <footer className="footer">
        <div className="text-center">
          <a href="https://softeasiest.linkpc.net/">Powered by Softeasiest Tech Pvt Ltd.</a>
        </div>
      </footer>

      <style>{`
        body {
          background-color: #f8fafc;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        .navbar-custom {
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
          padding: 1.25rem 5%;
        }
        .navbar{
          width: 100vw;
          height: 15vh;
        }
        .main{
          width: 100vw;
          height: 80vh;
          padding: 2%;
          overflow: auto;
        }
        .footer{
          width: 100vw;
          height: 5vh;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
        }
        .course-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
          border-radius: 12px;
          transition: all 0.3s ease;
          height: 100%;
        }
        .course-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
          border-color: #38bdf8;
        }
        .btn-custom-primary {
          border: 1px solid #0ea5e9;
          border-radius: 8px;
          font-weight: 500;
          transition: background-color 0.2s;
        }
        .btn-custom-primary:hover {
          background-color: #0284c7; /* Darker Sky Blue */
          color: white;
        }
        .btn-custom-outline {
          border: 1px solid #0ea5e9;
          color: #334155;
          font-weight: 500;
        }
        .btn-custom-outline:hover {
          color: #0ea5e9;
        }
        @media(max-width:600px){
          .navbar{
            height: 20vh;
          }
          .main{
            height: 70vh;
          }
          .footer{
            background: white;
            height: 5vh;
          }
        }
      `}</style>
    </>
  );
}